<template>
  <div class="container text-center flex flex-col items-center my-8">
    <span
      v-if="tagLine"
      class="inline-block sm:mt-6 mb-4 fluid-xs leading-tightest text__bg--highlight"
      v-html="tagLine"
    ></span>
    <h1 class="leading-none" :class="[headingSize === 'large' ? 'md:fluid-4xl' : 'md:fluid-3xl']">
      {{ heading }}
    </h1>
    <div
      v-if="teaserText"
      class="text-copy fluid-base leading-relaxed font-light w-full md:w-3/5 mt-4"
      data-test-id="teaserText"
      v-html="teaserText"
    ></div>
    <button
      v-if="showScrolldown"
      data-testid="btn-scroll-to-information"
      class="text-br-green mt-2 font-light"
      @click="moveToCollectionInformation"
    >
      + {{ $t('readMore') }}
    </button>
  </div>
</template>

<script>
import { Bus } from '@/utils/bus';
import { scrollToSelectorRespectingBars } from '@/utils/common';

export default defineNuxtComponent({
  props: {
    heading: {
      type: String,
      default: null,
    },
    teaserText: {
      type: String,
      default: null,
    },
    headingSize: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'large'].includes(value),
    },
    tagLine: {
      type: String,
      default: null,
    },
    showScrolldown: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    moveToCollectionInformation() {
      const anchor = document.querySelector('#collection-information');
      if (anchor) {
        Bus.emit('disable-infinity-loading');
        scrollToSelectorRespectingBars('#collection-information');
      }
    },
  },
});
</script>
